import React from 'react';

import qaserPlatform from './media/qaser-platform.png';
import qamialayerTunnel from './media/qamialayer-tunnel.png';
import govMessaging from './media/gov-messaging.png';
import citizenApp from './media/citizen-app.png';

const qaser = {
    intro: {
        title: (
            <>
                QASER <span style={{ fontSize: '0.6em', opacity: 0.7 }}>(كاسر)</span>
            </>
        ),
        subTitle: 'Sovereign Post-Quantum Cryptography Platform',
    },
    subIntro: {
        leftAligned: true,
        children: (
            <>
                <p>Quantum computers will break RSA and ECC encryption. "Harvest Now, Decrypt Later" attacks mean sensitive data captured today will be exposed when quantum computers mature. The NSA's CNSA 2.0 mandate requires quantum-resistant cryptography by 2030. The transition window is closing.</p>
            </>
        ),
    },
    divider: {},
    subIntro1: {
        children: (
            <>
                <h2>The QASER Platform</h2>
                <p>Four products. From discovery through permanent protection.</p>
            </>
        ),
    },
    cardsGroup: {
        children: [
            {
                icon: 'icon-search',
                title: 'QamiaScanner',
                card: "DISCOVER — Network cryptographic inventory. Risk scoring and remediation roadmap. Compliance mapping. Deployment: Instant.",
            },
            {
                icon: 'icon-shield-check',
                title: 'QamiaLayer',
                card: "PROTECT — Quantum-safe tunneling. Zero code changes. On-premises or cloud. Deployment: 4 weeks.",
            },
            {
                icon: 'icon-processor',
                title: 'QamiaIntegrate',
                card: "TRANSFORM — Full ML-KEM and ML-DSA implementation. Professional services included. Timeline: 6+ months.",
            },
            {
                icon: 'icon-layers',
                title: 'QamiaOrchestrator',
                card: "ORCHESTRATE — Crypto-agility management. Compliance monitoring. Certificate lifecycle. Service: Continuous.",
            },
        ],
    },
    imageSection: {
        children: (
            <img src={qaserPlatform} alt="QASER Platform - Four products from discovery through permanent protection" style={{ maxWidth: '100%', height: 'auto' }} />
        ),
    },
    divider1: {},
    subIntro2: {
        children: (
            <>
                <h2>How QamiaLayer Works</h2>
                <p>TLS doesn't support ML-KEM yet. Waiting for native PQ-TLS is years away. QamiaLayer solves this now.</p>
            </>
        ),
    },
    cardsGroup1: {
        children: [
            {
                icon: 'icon-check-circle',
                title: 'Zero Code Changes',
                card: "QamiaLayer sits between your clients and servers. Your applications see standard TLS. No modifications required.",
            },
            {
                icon: 'icon-shield-check',
                title: 'ML-KEM Protection',
                card: "Data transiting the network is protected by quantum-safe ML-KEM encryption inside the TLS tunnel.",
            },
            {
                icon: 'icon-timer',
                title: '4 Week Deployment',
                card: "From contract to production in 4 weeks. Works with your existing infrastructure immediately.",
            },
        ],
    },
    imageSection1: {
        children: (
            <img src={qamialayerTunnel} alt="QamiaLayer tunnel architecture - quantum-safe encryption without code changes" style={{ maxWidth: '100%', height: 'auto' }} />
        ),
    },
    divider2: {},
    subIntro3: {
        children: (
            <>
                <h2>Homegrown Cryptographic Libraries</h2>
                <p>Sovereign implementation of NIST post-quantum standards. No foreign dependencies in the cryptographic core.</p>
            </>
        ),
    },
    cardsGroup2: {
        children: [
            {
                icon: 'icon-lock',
                title: 'ML-KEM (FIPS 203)',
                card: "Quantum-safe key exchange. All parameter sets (512, 768, 1024). NIST KAT validated. OpenSSL provider integration.",
            },
            {
                icon: 'icon-file-check',
                title: 'ML-DSA (FIPS 204)',
                card: "Quantum-safe digital signatures. All parameter sets (44, 65, 87). Deterministic and randomized signing modes.",
            },
        ],
    },
    divider3: {},
    subIntro4: {
        children: (
            <>
                <h2>Why Sovereign Cryptography?</h2>
            </>
        ),
    },
    cardsGroup3: {
        children: [
            {
                icon: 'icon-globe',
                title: 'No Foreign Dependencies',
                card: "Your encryption keys and algorithms are not controlled by foreign vendors.",
            },
            {
                icon: 'icon-search',
                title: 'Full Source Access',
                card: "Audit the code yourself or engage regional security firms.",
            },
            {
                icon: 'icon-users',
                title: 'Local Support',
                card: "Direct access to the cryptographers who built the system.",
            },
            {
                icon: 'icon-toggle-on',
                title: 'Algorithm Agility',
                card: "Designed to swap algorithms as standards evolve.",
            },
        ],
    },
    divider4: {},
    subIntro5: {
        children: (
            <>
                <h2>Deployment Examples</h2>
                <p>QamiaLayer protecting real-world applications.</p>
            </>
        ),
    },
    imageSection2: {
        children: (
            <>
                <img src={govMessaging} alt="Government secure messaging protected by QamiaLayer" style={{ maxWidth: '100%', height: 'auto', marginBottom: '2rem' }} />
                <img src={citizenApp} alt="Citizen services app protected by QamiaLayer" style={{ maxWidth: '100%', height: 'auto' }} />
            </>
        ),
    },
    divider5: {},
    quote: {
        children: (
            <>
                Run QamiaScanner instantly. Deploy QamiaLayer in 4 weeks.
            </>
        ),
        cta: {
            url: `/contact`,
            children: 'Request a Demo',
        },
    },
};

export default qaser;
